import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'prestamo'

const PrestamoRepository = {
  detalle(idPrestamo) {
    let data = {
      idPrestamo,
    }
    return ApiService.get(`${REPOSITORY_URL}/detalle`, data)
  },
  calendario(anio) {
    let data = {
      anio,
    }
    return ApiService.get(`${REPOSITORY_URL}/calendario`, data)
  },
  cuotasPendientes() {
    return ApiService.get(`${REPOSITORY_URL}/cuotas_pendientes`)
  },
  resumenPrestamos(anio) {
    let data = {
      anio,
    }
    return ApiService.get(`${REPOSITORY_URL}/resumen`, data)
  },
  tieneResumenPrestamos(anioDesde, anioHasta) {
    let data = {
      anioDesde,
      anioHasta,
    }
    return ApiService.get(`${REPOSITORY_URL}/tiene_resumen_prestamos`, data)
  },


}

export default PrestamoRepository
